import { render, staticRenderFns } from "./EanReader.vue?vue&type=template&id=1873742a&scoped=true&"
import script from "./EanReader.vue?vue&type=script&lang=js&"
export * from "./EanReader.vue?vue&type=script&lang=js&"
import style0 from "./EanReader.vue?vue&type=style&index=0&id=1873742a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1873742a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VBtnToggle,VCard,VIcon,VTextField})
